import { BASE_PATH } from "..";
import type { SveaRequest } from "../../types/request";
import { APPCONFIG } from "../../utils/config";

export const initializePackageSigning: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package/sign-agreement`,
	method: "POST",
	body: {
		mode: sessionStorage.getItem("bankIdMode") || APPCONFIG.BANKID_MODE,
		provider: "eid",
	},
});

export const initializeGuarantorSigning: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/guarantor/sign-agreement`,
	method: "POST",
	body: {
		mode: sessionStorage.getItem("bankIdMode") || APPCONFIG.BANKID_MODE,
		provider: "eid",
	},
});

export const fetchSigningStatus: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/sign/collect`,
	method: "POST",
});

export const cancelSign: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/sign/cancel`,
	method: "POST",
	body: {
		provider: "eid",
	},
});
